export default __webpack_public_path__ + "static/media/sobre_desk2400.271c6a4c.webp";